// CHG-1289 / ITER-3414 — generic PermissionGate wrapper.
//
// Renders children only when the user has the given permission. Use
// inside generator screen configs / non-route surfaces to gate FAB
// buttons, bulk actions, edit buttons, etc. Per-route gating still
// lives in ProtectedRoute (which renders AccessDeniedPage); this
// component is for hiding individual affordances within a route the
// user CAN view (e.g. donor.read user sees the list, but not the
// donor.create FAB).
//
// Failure mode: returns null (hide affordance) when the user lacks
// the permission. Optionally renders a `fallback` (e.g. a disabled
// button + tooltip explaining the missing permission).
//
// Stronger isolation than a bare conditional render: the BE returns
// 403 if the user tries to call the gated endpoint anyway (defense in
// depth via the api/client interceptor).

import type { ReactNode } from "react";
import { useHasPermission } from "./usePermissions";

interface Props {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGate({ permission, children, fallback = null }: Props) {
  const allowed = useHasPermission(permission);
  if (!allowed) return <>{fallback}</>;
  return <>{children}</>;
}
